const root = '/'
const user = 'user/'
const core = 'core/'
const company = 'company/'
const companyManager = 'company-manager/'
const audit = 'audit/'


export const endpoints = {
  user: {
    crud: root + user,
    login: root + user + 'login/',
    logout: root + user + 'logout/',
    me: root + user + 'me/',
    permission: {
      list: root + user + 'user-permission/',
      approve: root + user + 'user-permission/{{ id }}/approve/',
      deny: root + user + 'user-permission/{{ id }}/deny/',
    },
  },
  core: {
    company: {
      crud: root + core + company,
    },
    companyManager: {
      crud: root + core + companyManager,
    },
  },
  audit: {
    giamSatTaiChinh: {
      financeInfo: root + audit + 'finance-info/',
      investmentStatusReport: root + audit + 'investment-status-report/',
      companyGradeReport: root + audit + 'company-grade-report/',
      companyManagerGradeReport: root + audit + 'company-manager-grade-report/',
      bulkInvestmentStatusReport: root + audit + 'bulk-investment-status-report/',
      bulkCompanyGradeReport: root + audit + 'bulk-company-grade-report/',
      bulkCompanyManagerGradeReport: root + audit + 'bulk-company-manager-grade-report/',
      gstcReportExcel: root + audit + 'gstc-report-excel/',
      recentReport: root + audit + 'gstc-recent-reports/',
    },
    danhGiaNDD: {
      companyRepresentativeReport: root + audit + 'company-representative-report/',
      bulkCompanyRepresentativeReport: root + audit + 'bulk-company-representative-report/',
      dgnddReportExcel: root + audit + 'dgndd-report-excel/',
      recentReport: root + audit + 'dgndd-recent-reports/',
    },
    summary: {
      companySummaryReport: root + audit + 'company-summary-report/',
      bulkCompanySummaryReport: root + audit + 'bulk-company-summary-report/',
      summaryReportExcel: root + audit + 'summary-report-excel/',
      recentReport: root + audit + 'summary-recent-reports/',
    },
  },
}
